export const rawsuggestions = [
  {
    branchcode: 130,
    label: "168 Mall",
    address:
      "4/F Unit 4H 09-11, 168 Mall Building 5, Soler St., Binondo, Manila"
  },
  {
    branchcode: 200,
    label: "999 Shopping Mall",
    address:
      "3/f, Unit 10 & 3C-2, 999 Shopping Mall 2, C.M. Recto Street, Tondo Manila"
  },
  {
    branchcode: 276,
    label: "A. Bonifacio-Balingasa",
    address:
      "G/F, 2/F & 3/F, Units D & E, Winston Building, No. 880 A. Bonifacio Avenue, Brgy. Balingasa, Quezon City"
  },
  {
    branchcode: 567,
    label: "A.Mabini-R.Salas",
    address:
      "G/F & 2/F Jesselton Tower No. 1453 A. Mabini St., corner R. Salas St., Brgy. 668, Zone 72, Ermita Manila"
  },
  {
    branchcode: 142,
    label: "Acropolis",
    address:
      "Unit 1B G/F Richmond Centre Building, Lot 46, Block 11, E. Rodriguez Jr. Avenue, Brgy. Bagumbayan, Acropolis, Quezon City"
  },
  {
    branchcode: 601,
    label: "Alabang - Frabelle",
    address:
      "Frabelle Alabang Bldg. 1100 Madrigal Business Park Alabang Zapote Rd Alabang Muntinlupa City"
  },
  {
    branchcode: 215,
    label: "Alabang Entrata",
    address:
      "Unit G3 & G4 Entrata, Filinvest Corporate City, Alabang, Muntinlupa City"
  },
  {
    branchcode: 290,
    label: "Alabang Hills",
    address: "Don Gesu Bldg., Don Jesus Blvd., Brgy. Cupang, Muntinlupa City"
  },
  {
    branchcode: 89,
    label: "Alabang Madrigal",
    address:
      "G/F CTP Alpha Bldg. Investment Drive Madrigal Business Park, Ayala Alabang, Muntinlupa City"
  },
  {
    branchcode: 146,
    label: "Alabang-Commerce Ave.",
    address:
      "Spectrum Center Block 28, Commerce Ave cor Filinvest Ave., Filinvest City, Alabang, Muntinlupa City"
  },
  {
    branchcode: 36,
    label: "Alabang-Westgate",
    address: "Westgate, Filinvest Corporate City,  Alabang Muntinlupa City 1770"
  },
  {
    branchcode: 201,
    label: "Amorsolo-Queensway",
    address:
      "G/F Queensway Building, No.118 Amorsolo St., Legaspi Village, Makati City"
  },
  {
    branchcode: 170,
    label: "Angeles-Balibago",
    address: "Saver's Mall Bldg. Mac Arthur Highway, Balibago Angeles City"
  },
  {
    branchcode: 31,
    label: "Annapolis",
    address:
      "G/F, The Meriden Condominium Building Unit 1A, Annapolis St. NorthEast, Greenhills San Juan City"
  },
  {
    branchcode: 14,
    label: "Anonas",
    address: "No. 94 Anonas Street corner K-6th, East Kamias, Quezon City"
  },
  {
    branchcode: 16,
    label: "Antipolo-Marcos Hi-way",
    address: "Ciannat Complex, Marcos Highway Brgy. Mayamot, Antipolo City"
  },
  {
    branchcode: 135,
    label: "Antipolo-ML Quezon",
    address:
      "No. 146 M.L.quezon Ave., cor. F. Dimanlig St., San Roque, Antipolo City"
  },
  {
    branchcode: 510,
    label: "Antique-San Jose",
    address: "St. Nicolas Building, T.A. Fornier Street, San Jose, Antique"
  },
  {
    branchcode: 571,
    label: "Aurora Blvd.-Anonas",
    address:
      "Rosario Building, No. 999 Aurora Blvd., near corner Lauan and Anonas Sts., Bgy. Duyan-duyan, Project 3, Quezon City"
  },
  {
    branchcode: 104,
    label: "Ayala Ave. - Makati Sky Plaza",
    address: "G/F Makati Sky Plaza Bldg. 6788 Ayala Avenue Makati City"
  },
  {
    branchcode: 9,
    label: "Ayala Ave.-Herrera",
    address:
      "G/F PBCom Tower, 6795 Ayala Ave. cor. V. Rufino St., (formerly Herrera St.), Salcedo Village, Makati City 1226"
  },
  {
    branchcode: 105,
    label: "Ayala Ave.-MSE",
    address:
      "G/F - Makati Stock Exchange Building, Ayala Triangle, Ayala Ave., Makati City"
  },
  {
    branchcode: 213,
    label: "Ayala Ave-Rufino",
    address:
      "G/F, Unit 1, Rufino Bldg., 6784 Ayala Ave. cor. V. A. Rufino St., Makati City"
  },
  {
    branchcode: 168,
    label: "Ayala Ave-SGV",
    address: "SGV 1 Bldg.,6760 Ayala Avenue, Makati City"
  },
  {
    branchcode: 97,
    label: "Baclaran",
    address:
      "2/F, New Galleria Baclaran Shopping Mall, LRT South Terminal, Taft Ave. Extension, Pasay City"
  },
  {
    branchcode: 584,
    label: "Bacolod - East",
    address:
      "East Two Corporate Center Building, Circumferential Road, Brgy. Villamonte, Bacolod City"
  },
  {
    branchcode: 503,
    label: "Bacolod-Araneta",
    address:
      "Unit 1A & 1B Metrodome Building, Araneta - Alunan St. Sincang, Barangay 39, Bacolod City"
  },
  {
    branchcode: 244,
    label: "Bacolod-Hilado",
    address: "Hilado Street, Bacolod City"
  },
  {
    branchcode: 85,
    label: "Bacolod-Lacson",
    address: "Lacson corner Luzuriaga Sts., Bacolod City"
  },
  {
    branchcode: 181,
    label: "Bacolod-Mandalagan",
    address: "Lopues Mandalagan Corp. Bldg., Brgy. Mandalagan, Bacolod City"
  },
  {
    branchcode: 20,
    label: "Bacoor-Aguinaldo Hi-way",
    address: "General E. Aguinaldo Highway Talaba Bacoor City Cavite"
  },
  {
    branchcode: 210,
    label: "Bacoor-Molino",
    address:
      "G/F Units 101, 102 & 103 VCENTRAL Mall Molino Bldg., Molino Blvd., Bacoor City, Cavite"
  },
  {
    branchcode: 155,
    label: "Baesa Town Center",
    address:
      "Baesa Town Center Retail Store#4 #232 Quirino Highway Baesa Quezon City"
  },
  {
    branchcode: 589,
    label: "Baguio - Legarda",
    address: "GF Lindi Hotel, #12 Legarda Road, Baguio City"
  },
  {
    branchcode: 163,
    label: "Baguio City-Session Rd.",
    address: "Unit B 101 Lopez Bldg Baguio Session"
  },
  {
    branchcode: 40,
    label: "Baguio-Rizal Monument",
    address:
      "One VF Tower, Benjamin Salvosa Drive, Brgy. Rizal Monument, Baguio City"
  },
  {
    branchcode: 18,
    label: "Bagumbayan",
    address: "184-B E. Rodriguez, Jr. Avenue, Bagumbayan, Libis, Quezon City"
  },
  {
    branchcode: 98,
    label: "Balintawak-A. Bonifacio",
    address:
      "g/f, 2/f & 3/f, Units D & E, Winston Building, No. 880 A. Bonifacio Avenue, Brgy. Balingasa, Quezon City"
  },
  {
    branchcode: 76,
    label: "Baliuag",
    address:
      "Doña Remedios Trinidad Highway corner Benigno S. Aquino Ave., Baliuag, Bulacan"
  },
  {
    branchcode: 295,
    label: "Banawe-Kaliraya",
    address:
      "Titan 168 Building, 126 Banawe Street near corner Kaliraya St., Brgy. Tatalon, Quezon City"
  },
  {
    branchcode: 162,
    label: "Banawe-N. Roxas",
    address: "No. 42 Banawe Ave. cor. Nicanor Roxas, Quezon City"
  },
  {
    branchcode: 156,
    label: "Banawe-Sct. Alcaraz",
    address:
      "Unit ABC G/F #740 Banawe Ave. near cor. Scout Alcaraz, Quezon City"
  },
  {
    branchcode: 120,
    label: "Bataan-Balanga",
    address:
      "Don Manuel Banzon Ave. Cor. Cuaderno St. Dona Fransica Balanga City, Bataan"
  },
  {
    branchcode: 239,
    label: "Bataan-Dinalupihan",
    address: "Bgy. San Ramon, Dinalupihan, Bataan"
  },
  {
    branchcode: 561,
    label: "Bataan-Mariveles",
    address: "8th Avenue, Freeport Area of Bataan (FAB), Mariveles, Bataan"
  },
  {
    branchcode: 55,
    label: "Batangas City",
    address:
      "54-A D. Silang St. cor. Pastor St., Brgy. 14 Poblacion, Batangas City"
  },
  {
    branchcode: 580,
    label: "Batangas City - Pallocan",
    address:
      "Unit Nos. 6, 7, and 8, Mayvel Center Building, Manuela Pastor Avenue, Brgy. Pallocan West, Batangas City"
  },
  {
    branchcode: 552,
    label: "Batangas-Balayan",
    address: "cor. Paz St. and Union St., Poblacion, Balayan, Batangas"
  },
  {
    branchcode: 214,
    label: "Batangas-Bauan",
    address: "J.P. Rizal Street corner San Agustin Street, Bauan, Batangas"
  },
  {
    branchcode: 502,
    label: "Batangas-Lemery",
    address: "g/f LDMC Building, Ilustre Ave. Brgy. Rizal, Lemery, Batangas"
  },
  {
    branchcode: 530,
    label: "Batangas-Nasugbu",
    address: "J. P. Laurel Street, Poblacion, Nasugbu, Batangas"
  },
  {
    branchcode: 511,
    label: "Batangas-Rosario",
    address: "Rosario-Padre Garcia-Lipa Road, Poblacion Rosario, Batangas"
  },
  {
    branchcode: 544,
    label: "Batangas-Sto. Tomas",
    address: "KM 67 Maharlika Highway, Poblacion Sto. Tomas, Batangas"
  },
  {
    branchcode: 267,
    label: "Batangas-Tanauan",
    address: "No. 98 J.P. Laurel Hi-way, Brgy. Darasa,Tanauan City"
  },
  {
    branchcode: 197,
    label: "Benavidez",
    address:
      "Unit 103, One Corporate Plaza, Benavidez St. Legaspi Village, San Lorenzo, Makati City"
  },
  {
    branchcode: 247,
    label: "Benguet-La Trinidad",
    address: "KM 5, Central Pico, La Trinidad, Benguet"
  },
  {
    branchcode: 171,
    label: "Better Living-Peru",
    address:
      "Blk 9, Lot 3 Dona Soledad Ave. cor. Peru St., BetterLiving, Paranaque City"
  },
  {
    branchcode: 12,
    label: "BetterLiving-Doña Soledad",
    address:
      "No. 100 Dona Soledad Avenue,  Betterliving Subd.Barangay Don Bosco, Paranaque City 1711"
  },
  {
    branchcode: 206,
    label: "BF Homes-Aguirre",
    address: "No. 327 Aguirre Avenue, BF Homes, Paranaque City"
  },
  {
    branchcode: 277,
    label: "Bicutan-East Service Rd",
    address:
      "G/F, Waltermart Bicutan, East Service Rd., cor. Mañalac Ave., Brgy. San Martin de Porres, Parañaque City"
  },
  {
    branchcode: 74,
    label: "Binondo",
    address:
      "G/F, Uy Su Bin Bldg., 535-537 Quintin Paredes St., Binondo, Manila"
  },
  {
    branchcode: 525,
    label: "Blumentritt-Rizal Ave.",
    address: "No. 2412 Rizal Avenue, Sta. Cruz, Manila"
  },
  {
    branchcode: 216,
    label: "Boni Avenue",
    address:
      "G/F Lourdes Bldg. II 667 Boni Ave. Bgy. PlainView Mandaluyong City"
  },
  {
    branchcode: 572,
    label: "Boni Serrano Ave.",
    address: "No. 107 Boni Serrano Avenue, Brgy. Lipunan ng Crame, Quezon City"
  },
  {
    branchcode: 217,
    label: "Boracay",
    address:
      "Alexandrea Bdlg., Main Road Brgy. Balabag Boracay Island, Malay Aklan"
  },
  {
    branchcode: 281,
    label: "Bukidnon-Valencia",
    address:
      "Tamay Lang Lang Park Lane Bldg., G. La Viña Ave., Poblacion, Valencia City, Bukidnon"
  },
  {
    branchcode: 577,
    label: "Bulacan - Sta. Maria",
    address: "No. 115 M. De Leon St., Brgy., Poblacion, Sta. Maria, Bulacan"
  },
  {
    branchcode: 297,
    label: "Bulacan-Balagtas",
    address: "Burol 1st, Mc Arthur Highway, Balagtas Bulacan"
  },
  {
    branchcode: 282,
    label: "Bulacan-Plaridel",
    address:
      "Lot 1071- A, Daang Maharlika Road, (Prev. Cagayan Valley Road) Banga First, Plaridel Bualacan"
  },
  {
    branchcode: 557,
    label: "Bulacan-San Jose Del Monte",
    address:
      "Dalisay Resort, Gov. F. Halili Avenue, Tungkong Mangga, San Jose del Monte, Bulacan"
  },
  {
    branchcode: 123,
    label: "Butuan City",
    address:
      "G/F, Deofevente Bldg., Lot No. 7, Governor J. Rosales Ave., Brgy. Imadejas, Butuan City"
  },
  {
    branchcode: 591,
    label: "Butuan-P. Burgos",
    address:
      "Units 1, 2, and 3 g/f FSUU Building, P. Burgos corner San Francisco Streets, Brgy. Sikatuna, Butuan City"
  },
  {
    branchcode: 113,
    label: "C. Raymundo Ave.",
    address:
      "G/F ITSP Building, No. 172 C. Raymundo Ave., Brgy. Maybunga, Pasig City"
  },
  {
    branchcode: 573,
    label: "Cabanatuan-Maharlika",
    address: "Maharlika Highway, Brgy. Dicarma, Cabanatuan City, Nueva Ecija"
  },
  {
    branchcode: 33,
    label: "Cabanatuan-Melencio",
    address: "Melencio St. corner Gen. Luna ST, Cabanatuan City"
  },
  {
    branchcode: 604,
    label: "Cagayan De Oro - Pueblo de Oro",
    address:
      "VLC Tower One, B1 L1, Gran Via St., Pueblo de Oro, Cagayan de Oro City"
  },
  {
    branchcode: 549,
    label: "Cagayan de Oro-Carmen",
    address: "RTS Bldg., Vamenta Blvd., Carmen, Cagayan de Oro City"
  },
  {
    branchcode: 219,
    label: "Cagayan de Oro-Cogon",
    address:
      "De Oro Construction Supply, Inc Bldg., Don Sergio Osmenia St. cor Limketkai Drive Cagayan de Oro City"
  },
  {
    branchcode: 550,
    label: "Cagayan de Oro-Lapasan",
    address: "Lapasan Highway, Cagayan de Oro City"
  },
  {
    branchcode: 38,
    label: "Cagayan de Oro-Velez",
    address:
      "Juan Sia Bldg., No. 50  Don Apolinar Velez St. Cagayan de Oro City"
  },
  {
    branchcode: 35,
    label: "Calamba",
    address: "G/F, SQA Bldg, Brgy. Uno, Crossing, Calamba City, Laguna"
  },
  {
    branchcode: 583,
    label: "Calamba - National Road",
    address: "No. 1425 National Road, Brgy. Uno Crossing, Calamba Laguna 4027"
  },
  {
    branchcode: 144,
    label: "Caloocan-A. Mabini",
    address:
      "G/F Gee Bee Bldg. No. 428 A. Mabini St., Brgy. 15, Zone 2, Caloocan City"
  },
  {
    branchcode: 587,
    label: "Candelaria",
    address:
      "corner National Highway and Ona Street, Brgy. Poblacion Candelaria Quezon"
  },
  {
    branchcode: 106,
    label: "Carmona",
    address:
      "Lot 1947-B, Paseo de Carmona Compound, Governor's Drive, Brgy. Maduya, Carmona, Cavite "
  },
  {
    branchcode: 529,
    label: "Catbalogan City",
    address: "Curry Avenue corner San Bartolome Street, Catbalogan City, Samar"
  },
  {
    branchcode: 593,
    label: "Cavite - Rosario",
    address: "Lot 616 F1 Gen. Trias Drive, Tejeros Convention Rosario, Cavite"
  },
  {
    branchcode: 284,
    label: "Cavite City",
    address: "P. Burgos Ave., Brgy. Caridad, Cavite City"
  },
  {
    branchcode: 221,
    label: "Cavite-Naic",
    address: "Ibayo Silangan cor. Sabang Road, Naic Cavite"
  },
  {
    branchcode: 517,
    label: "Cavite-Silang",
    address:
      "No. 132 J. P Rizal Street, corner E. Montoya Street, Brgy. San Vicente I, Silang, Cavite"
  },
  {
    branchcode: 222,
    label: "Cavite-Tanza",
    address: "Antero Soriano Highway, Daang Amaya 2, Tanza, Cavite"
  },
  {
    branchcode: 299,
    label: "Cavite-Trece Martires",
    address:
      "g/f Dionets Commercial Place Building,Trece Martires-Indang Road, Brgy. San Agustin, Trece Martires City, Cavite"
  },
  {
    branchcode: 224,
    label: "Cebu IT Park",
    address:
      "G/F, Calyx Center, W. Ginonzon Street corner Abad Street, Asia Town, IT Park, Cebu City"
  },
  {
    branchcode: 115,
    label: "Cebu Mactan",
    address: "G/F Bldg. II, M. L. Quezon National Highway Pusok, Lapu-lapu City"
  },
  {
    branchcode: 228,
    label: "Cebu-A.C. Cortes",
    address:
      "Carlos Perez Building, A.C. Cortes Avenue, Brgy. Ibabao, Mandaue City, Cebu"
  },
  {
    branchcode: 173,
    label: "Cebu-A.S. Fortuna",
    address: "AYS Bldg., A.S. Fortuna St., Brgy. Banilad, Mandaue City, Cebu"
  },
  {
    branchcode: 60,
    label: "Cebu-Banilad",
    address:
      "G/F Unit 101 of PDI Condominium Gov. M. Cuenco Ave. corner J. Panis St. Banilad, Cebu City"
  },
  {
    branchcode: 229,
    label: "Cebu-Basak Pardo",
    address:
      "South Point Place Building, N. Balasco Ave., South Road, Basak Pardo, Cebu City"
  },
  {
    branchcode: 230,
    label: "Cebu-Freedom Park",
    address:
      "CLC Bldg., 280 Magallanes St. near corner Noli Me Tangere, Cebu City"
  },
  {
    branchcode: 223,
    label: "Cebu-Fuente Osmeña",
    address: "G/F Cebu Women's Club Building Fuente Osmeña, Cebu City"
  },
  {
    branchcode: 139,
    label: "Cebu-Grand Cenia",
    address: "Grand Cenia Bldg., Archbishop Reyes Avenue, Cebu City"
  },
  {
    branchcode: 225,
    label: "Cebu-Juan Luna",
    address: "Stephen Jo Building, Juan Luna, Cebu City"
  },
  {
    branchcode: 174,
    label: "Cebu-M. Velez",
    address: "No. 151, M. Velez St., Guadalupe, Cebu City"
  },
  {
    branchcode: 61,
    label: "Cebu-Magallanes",
    address: "Go Quiaco Bldg. Magallanes cor Gonzales Sts, Cebu City"
  },
  {
    branchcode: 133,
    label: "Cebu-Mandaue North Road",
    address: "G/F, ALDO Bldg., North Road, Basak, Mandaue City, Cebu"
  },
  {
    branchcode: 57,
    label: "Cebu-Mandaue Subangdaku",
    address: "Kina Building, National Highway, Subangdaku, Mandaue City, Cebu"
  },
  {
    branchcode: 226,
    label: "Cebu-Minglanilla",
    address:
      "G/F La Nueva - Minglanilla Center, Ward 2, Poblacion Minglanilla Cebu 6046"
  },
  {
    branchcode: 41,
    label: "Cebu-N. Escario",
    address:
      "Cebu Capitol Commercial Complex Bldg. N. Escario Street, Cebu City"
  },
  {
    branchcode: 188,
    label: "Cebu-Park Mall",
    address: "Alfresco 4, Units 39, 40 & 40a Parkmall, Mandaue City"
  },
  {
    branchcode: 227,
    label: "Cebu-Talisay",
    address: "Paul Sy Bldg Highway Tabunok, Talisay City, Cebu"
  },
  {
    branchcode: 160,
    label: "Chino Roces-Bagtikan",
    address:
      "G/F High Pointe Bldg. No. 1184 Chino Roces Ave. near corner Bagtikan, Brgy. San Antonio, Makati City"
  },
  {
    branchcode: 96,
    label: "Chino Roces-Dela Rosa",
    address:
      "G/f, King's Court II Bldg., No. 2129 Don Chino Roces Ave., cor Dela Rosa St., Makati City"
  },
  {
    branchcode: 527,
    label: "Chino Roces-La Fuerza",
    address:
      "Unit/s 10 & 11 La Fuerza Plaza 1, 2241 Don Chino Roces Avenue, Makati City"
  },
  {
    branchcode: 154,
    label: "City Place Square",
    address:
      "3/F C-P2-3, Cityplace Square, Reina Regente near corner Felipe II St., Binondo, Manila"
  },
  {
    branchcode: 231,
    label: "Commonwealth",
    address:
      "G/F, Crissant Plaza Bldg., No. 272 Commonwealth Ave., Brgy. Old Balara, Quezon City"
  },
  {
    branchcode: 13,
    label: "Congressional Ave.",
    address: "Congressional Ave. Brgy. Bahay Toro Project 8, Quezon City"
  },
  {
    branchcode: 63,
    label: "Cotabato City",
    address: "No. 31 Quezon Avenue, Poblacion 5, Cotabato City"
  },
  {
    branchcode: 232,
    label: "Cubao-Araneta Center",
    address:
      "G/F, Philamlife Building, Aurora Blvd. corner General Araneta Street, Cubao, Quezon City"
  },
  {
    branchcode: 2,
    label: "Cubao-P. Tuazon",
    address:
      "G/F, Prince John Condominium, No. 291 P. Tuazon Ave.corner 18th Ave., Cubao, Quezon City"
  },
  {
    branchcode: 233,
    label: "Dagupan-A.B. Fernandez",
    address: "New Star Bldg. A.B Fernandez Avenue. Dagupan City."
  },
  {
    branchcode: 37,
    label: "Dagupan-Perez",
    address:
      "Lot 194 D1-A & Lot 194 D1-B, Brgy. Pogo Chico, Perez  Blvd, Dagupan City"
  },
  {
    branchcode: 234,
    label: "Dasmariñas",
    address:
      "Km. 31 Gen. Emelio Aguinaldo Highway, Brgy. Zone 4, Dasmariñas City, Cavite"
  },
  {
    branchcode: 518,
    label: "Davao-Agdao",
    address: "Door 2&3 Cabaguio Plaza, Cabaguio Ave., Agdao, Davao City"
  },
  {
    branchcode: 211,
    label: "Davao-Bajada",
    address:
      "Carolina Uykimpang Bldg., Corner Iñigo St., J.P. Laurel Avenue Davao City"
  },
  {
    branchcode: 285,
    label: "Davao-Buhangin",
    address:
      "G/F, D3G Bldg., Km. 5 Buhangin Road cor. Gladiola St., Buhangin, Davao City"
  },
  {
    branchcode: 176,
    label: "Davao-C.M. Recto",
    address: "P&E Building, Poblacion, Brgy. 035 C.M. Recto Avenue, Davao City"
  },
  {
    branchcode: 507,
    label: "Davao-Digos",
    address:
      "Commercial Space-4, Davao RJ and Sons Realty & Trading Corporation Building, V. Sotto Street, Brgy. Zone-1, Digos City, Davao del Sur"
  },
  {
    branchcode: 585,
    label: "Davao-Diversion Road",
    address:
      "Unit 4&5, G/F D3G Y10 Bldg.,C.P. Garcia National Highway, Brgy. Cabantian Davao City"
  },
  {
    branchcode: 235,
    label: "Davao-J.P. Laurel",
    address: "JP Laurel Avenue, Davao City"
  },
  {
    branchcode: 70,
    label: "Davao-Lanang",
    address: "Lot 6, Blk 5, Insular Village, Pampanga, Lanang, Davao City"
  },
  {
    branchcode: 594,
    label: "Davao-Ma-a",
    address:
      "G/F, Rosario Bldg., Don Julian Rodriguez Avenue, Ma-a Road Davao City"
  },
  {
    branchcode: 548,
    label: "Davao-Magsaysay",
    address:
      "EWB Bldg. Lot 100-C Brgy. 030 Poblacion, R. Magsaysay Ave., Davao City"
  },
  {
    branchcode: 77,
    label: "Davao-Matina",
    address: "Lot 16 Blk 3, McArthur Highway, Matina, Davao City"
  },
  {
    branchcode: 519,
    label: "Davao-McArthur Matina",
    address:
      "BGP Commercial Complex II Bldg., McArthur Highway, Matina, Davao Ctiy"
  },
  {
    branchcode: 236,
    label: "Davao-Panabo City",
    address: "Quezon Street, Sto. Niño, Panabo City, Davao del Norte"
  },
  {
    branchcode: 547,
    label: "Davao-Quirino",
    address:
      "Centron Building, Quirino Avenue corner General Luna Street, Davao City"
  },
  {
    branchcode: 71,
    label: "Davao-Sta. Ana",
    address: "g/f, GH Depot Bldg., Gov. Sales St., Sta. Ana, Davao City"
  },
  {
    branchcode: 134,
    label: "Davao-Toril",
    address: "Saavedra St., Toril, Davao City"
  },
  {
    branchcode: 72,
    label: "Del Monte",
    address: "271 Del Monte cor. Biak na Bato, Quezon City"
  },
  {
    branchcode: 535,
    label: "Del Monte-D. Tuazon",
    address: "No. 155 Del Monte Ave., Brgy. Manresa, Quezon City"
  },
  {
    branchcode: 522,
    label: "Dipolog City",
    address: "G/F Felicidad II Bldg., Quezon Ave., Miputak, Dipolog City"
  },
  {
    branchcode: 86,
    label: "Divisoria",
    address: "No. 802 Ilaya St., Binondo Manila"
  },
  {
    branchcode: 153,
    label: "Don Antonio Heights",
    address:
      "Lot 24 Block 7, Holy Spirit Drive, Don Antonio Heights Brgy. Holy Spirit Quezon City"
  },
  {
    branchcode: 240,
    label: "Dumaguete City",
    address: "Don Joaquin T. Villegas Bldg., Colon St., Dumaguete City"
  },
  {
    branchcode: 165,
    label: "E. Rodriguez Ave.",
    address:
      "G/F MC RILLO BLDG. No. 1168 E. Rodriguez Ave.,Brgy. Mariana Quezon City"
  },
  {
    branchcode: 537,
    label: "E. Rodriguez Ave.-Cubao",
    address:
      "No. 1731 E. Rodriguez Sr. Avenue, Brgy. Pinagkaisahan, Cubao, Quezon City"
  },
  {
    branchcode: 563,
    label: "E.Rod-Welcome Rotonda",
    address:
      "G/F, AEK Bldg., No. 40 E. Rodriguez Sr. Ave., Brgy. Don Manuel, Quezon City"
  },
  {
    branchcode: 204,
    label: "Eastwood City",
    address:
      "Unit D, Technoplaza One Building, Eastwood City Cyberpark, No. 188 E.Rodriguez Jr. Ave., Bagumbayan, Quezon City"
  },
  {
    branchcode: 164,
    label: "Edsa Howmart",
    address:
      "No. 1264 EDSA near corner Howmart Road, Brgy. A. Samson, Quezon City"
  },
  {
    branchcode: 5,
    label: "EDSA-Kalookan",
    address: "No. 490 EDSA, Kalookan City"
  },
  {
    branchcode: 177,
    label: "EDSA-Muñoz",
    address:
      "G/F Lemon Square Bldg., 1199 EDSA Muñoz, Bgry. Katipunan, Quezon City"
  },
  {
    branchcode: 241,
    label: "Elcano",
    address:
      "G/F, Elcano Plaza Building, No. 622 ElCano Street, Binondo, Manila"
  },
  {
    branchcode: 28,
    label: "Escolta",
    address:
      "Unit 3, G/F, First United Bldg., 413 Escolta corner Banquero St., Binondo, Manila"
  },
  {
    branchcode: 118,
    label: "Evangelista",
    address:
      "No. 1806 Evangelista St. corner Hen. Mojica St., Brgy. Bangkal, Makati City"
  },
  {
    branchcode: 3,
    label: "F. Ortigas Jr.",
    address:
      "Unit G103, g/f, AIC Gold Tower Condominium, F. Ortigas, Jr. Road, corner Garnet and Sapphire Sts., Ortigas Center. Pasig City"
  },
  {
    branchcode: 242,
    label: "Fairview",
    address:
      "No. 72 Commonwealth Ave. corner Camaro St., East Fairview. Quezon City"
  },
  {
    branchcode: 51,
    label: "Festival Mall Level 1",
    address:
      "X-cite Area, Level 1, Festival Supermall, Filinvest Corp. City, Alabang Muntinlupa City 1781"
  },
  {
    branchcode: 30,
    label: "Festival Mall Level 2",
    address:
      "Level 2, Unit 2115 - 2118, Festival Supermall Filinvest Corporate City, Alabang Muntinlupa City 1781"
  },
  {
    branchcode: 198,
    label: "G. Araneta Ave.",
    address:
      "Units A & B, Ilo Bldg., No. 195 G. Araneta Ave., Brgy. Santol, Quezon City"
  },
  {
    branchcode: 509,
    label: "General Luis-Kaybiga",
    address: "No. 4 Gen. Luis St., Barangay Kaybiga, Caloocan City"
  },
  {
    branchcode: 553,
    label: "General Santos City-Calumpang",
    address:
      "Calumpang Medical Specialist Building, National Highway, Calumpang, General Santos City"
  },
  {
    branchcode: 523,
    label: "General Santos-Pioneer",
    address: "Pioneer Avenue corner Magsaysay Avenue, General Santos City"
  },
  {
    branchcode: 117,
    label: "General Santos-Santiago",
    address: "Ireneo Santiago Boulevard, General Santos City"
  },
  {
    branchcode: 124,
    label: "General Trias",
    address:
      "G/F, Unit 102 VCentral Gentri Bldg., Governor's Drive, Manggahan, General Trias, Cavite"
  },
  {
    branchcode: 275,
    label: "Gil Puyat-Dian",
    address:
      "G/F, Wisma Cyberhub Building, No. 45 Sen. Gil Puyat Ave., Makati City"
  },
  {
    branchcode: 140,
    label: "Gil Puyat-F.B. Harrison",
    address: "No. 131 Gil Puyat Avenue Extension, Brgy 24, Zone 4, Pasay City"
  },
  {
    branchcode: 1,
    label: "Gil Puyat-Metro House",
    address: "G/F Metro House Bldg., 345 Sen. Gil Puyat Ave.,, Makati City"
  },
  {
    branchcode: 185,
    label: "Gil Puyat-Pacific Star",
    address: "G/F, Pacific Star Bldg., Sen Gil Puyat Ave. Makati City"
  },
  {
    branchcode: 528,
    label: "Gil Puyat-Salcedo Vill.",
    address:
      "Unit 1C, g/f, Country Space 1 Bldg., Gil Puyat Avenue, Makati City"
  },
  {
    branchcode: 286,
    label: "Grace Park-11th Ave.",
    address:
      "G/F, Remcor V Building, Block 172, Lot 5, Rizal Avenue Ext., Caloocan City"
  },
  {
    branchcode: 512,
    label: "Grace Park-3rd Ave.",
    address: "No. 215 Rizal Avenue Ext. Brgy. 45 Grace Park West, Caloocan City"
  },
  {
    branchcode: 209,
    label: "Grace Park-7th Ave.",
    address:
      "G/F Units 1,2, & 3 No. 330 Rizal Ave. Ext., near cor. 7th Avenue, East Grace Park, Caloocan City"
  },
  {
    branchcode: 73,
    label: "Grace Park-8th Ave.",
    address: "No. 896 8th Avenue cor. J. Teodoro, Grace Park, Caloocan City"
  },
  {
    branchcode: 138,
    label: "Greenhills Shopping Center",
    address:
      "Units G-102B, Greenlanes Arcade., Greenhills Shopping Center, San Juan City"
  },
  {
    branchcode: 175,
    label: "Greenhills-Connecticut",
    address:
      "Unit B, G/F Fox Square Building No. 53 Connecticut Street, Northeast Greenhills San Juan City"
  },
  {
    branchcode: 272,
    label: "Greenhills-North",
    address:
      "G/F BTTC Bldg., Ortigas Ave. cor. Roosevelt St., Greenhills, San Juan City"
  },
  {
    branchcode: 526,
    label: "Greenhills-Promenade",
    address:
      "Unit 3, g/f & 2/f Promenade Building, Missouri Street, Greenhills, San Juan City"
  },
  {
    branchcode: 46,
    label: "Greenhills-West",
    address: "G/F ALCCO Bldg. Ortigas Avenue Greenhills-West, San Juan City"
  },
  {
    branchcode: 237,
    label: "H.V. Dela Costa",
    address:
      "Unit GFC-2, Classica 1 Condominium (Building), 112 H.V. Dela Costa St., Salcedo Village, Makati City"
  },
  {
    branchcode: 111,
    label: "Iligan City",
    address: "G/F, Party Plaza Bldg., Quezon Ave. Ext., Rabago, Iligan City"
  },
  {
    branchcode: 515,
    label: "Ilocos Norte-San Nicolas",
    address: "Barangay 2, San Nicolas, Ilocos Norte"
  },
  {
    branchcode: 172,
    label: "Ilocos Sur-Candon",
    address: "G/F KAMSU Building Brgy San Jose, Candon City, Ilocos Sur"
  },
  {
    branchcode: 588,
    label: "Iloilo-Diversion",
    address:
      "The 21 Avenue Building, Benigno Aquino Avenue, Mandurriao, Iloilo City"
  },
  {
    branchcode: 131,
    label: "Iloilo-Iznart",
    address: "G/F, B&C Square Bldg., Iznart St. cor. Solis St., Iloilo City"
  },
  {
    branchcode: 245,
    label: "Iloilo-Jaro",
    address:
      "Jaro Townsquare, Mandaue Foam Building, Quintin Salas, Jaro, Iloilo City"
  },
  {
    branchcode: 80,
    label: "Iloilo-Ledesma",
    address:
      "Sta. Cruz Arancillo Bldg. Ledesma corner Fuentes Sts., Iloilo City"
  },
  {
    branchcode: 145,
    label: "Iloilo-Molo",
    address: "GT Plaza Mall, MH del Pilar St., Molo, Iloilo City"
  },
  {
    branchcode: 10,
    label: "Imus",
    address: "G/F, LDB Bldg., 552 Gen. Aguinaldo Highway, Imus City, Cavite"
  },
  {
    branchcode: 69,
    label: "Intramuros",
    address:
      "G/F, BF Condominium, 104 A. Soriano Avenue corner Solana St., Intramuros, Manila"
  },
  {
    branchcode: 581,
    label: "Isabela - Roxas",
    address: "Maharlika Hi-way Brgy. Bantug Roxas Isabela 3320"
  },
  {
    branchcode: 83,
    label: "Isabela-Cauayan",
    address: "Maharlika Highway Cauayan City, Isabela"
  },
  {
    branchcode: 513,
    label: "Isabela-Ilagan",
    address:
      "Maharlika Highway corner Florencio Apostol Street, Calamagui 1, Ilagan, Isabela"
  },
  {
    branchcode: 66,
    label: "Isabela-Santiago",
    address:
      "Midori Bldg, National Highway, Villasis, Santiago City, Isabela 3311"
  },
  {
    branchcode: 208,
    label: "J.P. Rizal",
    address:
      "No. 805 J.P. Rizal cor. F. Zobel St., San Miguel Village, Makati City"
  },
  {
    branchcode: 166,
    label: "Jose Abad Santos-Tayuman",
    address:
      "G/F & 2/F Cada Bldg., 1200 Tayuman St., cor. Jose Abad Santos Ave.Tondo, Manila"
  },
  {
    branchcode: 531,
    label: "Juan Luna-Binondo",
    address: "No. 580 Juan Luna St. Binondo Manila"
  },
  {
    branchcode: 279,
    label: "Juan Luna-Pritil",
    address: "G/F 1953-1955 Juan Luna St., Tondo, Manila"
  },
  {
    branchcode: 246,
    label: "Julia Vargas",
    address:
      "G/F, Unit 101 One Corporate Centre Office Condominium, Doña Julia Vargas Avenue corner Meralco Avenue, Ortigas Center, Pasig City"
  },
  {
    branchcode: 521,
    label: "Jupiter-Paseo de Roxas",
    address:
      "No. 30 Jupiter cor. Paseo De Roxas Sts., Brgy. Bel-Air, Makati City"
  },
  {
    branchcode: 574,
    label: "Kalayaan-Matalino",
    address:
      "No. 123 Kalayaan Avenue near corner Matalino St. Brgy. Central Diliman, Quezon City"
  },
  {
    branchcode: 278,
    label: "Kalentong",
    address: "No. 908 Gen. Kalentong Street, Mandaluyong City"
  },
  {
    branchcode: 505,
    label: "Kalibo",
    address: "Roxas Avenue Extension, Kalibo, Aklan"
  },
  {
    branchcode: 178,
    label: "Kamias",
    address:
      "No. 10 Kamias Rd., cor. Col Salgado St., Brgy. West Kamias, Quezon City"
  },
  {
    branchcode: 562,
    label: "Kamuning",
    address: "JPY Bldg, No. 52 Kamuning Road, Brgy Kamuning Quezon City"
  },
  {
    branchcode: 27,
    label: "Katipunan-St. Ignatius",
    address: "No. 132 Katipunan Ave., St. Ignatius Village, Quezon city"
  },
  {
    branchcode: 543,
    label: "Kawit-Centennial",
    address: "Centennial Road, Tabon, Kawit, Cavite"
  },
  {
    branchcode: 551,
    label: "Kidapawan",
    address:
      "Doña Leonila Complex, National Highway, Poblacion, Kidapawan City,North Cotabato"
  },
  {
    branchcode: 179,
    label: "Koronadal City",
    address:
      "G/F, RCA Building, Gen. Santos Drive, Koronadal City, South Cotabato"
  },
  {
    branchcode: 514,
    label: "La Union-Agoo",
    address: "Mac Arthur Highway, Barangay San Antonio, Agoo, La Union"
  },
  {
    branchcode: 62,
    label: "La Union-San Fernando",
    address: "Kenny Plaza, Brgy. Catbangen, Quezon Ave. San Fernando La Union"
  },
  {
    branchcode: 248,
    label: "Lagro",
    address: "Lot 2-B-6 Quirino Highway, Lagro, Novaliches, Quezon City"
  },
  {
    branchcode: 501,
    label: "Laguna-Biñan",
    address:
      "G/F, Units 1,2,3 & 4, Simrey's Commercial Building, National Highway corner Alma Manzo Road, Brgy. San Antonio, Biñan City, Laguna"
  },
  {
    branchcode: 283,
    label: "Laguna-Cabuyao",
    address: "No. 26 J. P. Rizal Street, Poblacion, Cabuyao City, Laguna"
  },
  {
    branchcode: 582,
    label: "Laguna-Sta. Cruz",
    address:
      "Sun Moon Arcade Building, No. 129 P. Guevara Ave., Poblacion 2 , Sta Cruz, Laguna"
  },
  {
    branchcode: 59,
    label: "Laoag City",
    address:
      "G/F Puregolds Bldg., Commercial Unit No. 3 & 4 Nolasco St., cor Castro Ave., and J.P. Pizal, Laoag City"
  },
  {
    branchcode: 271,
    label: "Las Piñas-Almanza",
    address:
      "Aurora Arcade Bldg., Alabang Zapote Road, Almanza Uno, Las Pinas City"
  },
  {
    branchcode: 129,
    label: "Las Piñas-BF Resort",
    address:
      "B.F. Resort Drive, Phase IV, BF Resort Village, Las Pinas City 1740"
  },
  {
    branchcode: 539,
    label: "Las Piñas-J.Aguilar Ave.",
    address:
      "J.Aguilar Avenue corner Casimiro Drive, Brgy. BF International, Las Piñas City, Metro Manila"
  },
  {
    branchcode: 182,
    label: "Las Piñas-Marcos Alvarez",
    address: "No. 575 Marcos Alvarez Ave., Talon V, Las Pinas"
  },
  {
    branchcode: 4,
    label: "Las Piñas-Pamplona",
    address: "Lot 16B PSD 208390 Alabang Zapote Road Las Piñas City"
  },
  {
    branchcode: 575,
    label: "Legaspi-Aguirre",
    address:
      "G/F, Unit 1-B, The Biltmore, No. 102 Aguirre Street, Legaspi Village, Makati City"
  },
  {
    branchcode: 238,
    label: "Legaspi-Dela Rosa",
    address:
      "G/F, I - Care Bldg., No. 167 Legaspi cor Dela Rosa Sts., Legaspi Village, Makati City"
  },
  {
    branchcode: 103,
    label: "Legaspi-Rufino",
    address:
      "G/F - Libran Bldg., Legaspi St. corner V.A. Rufino Ave., Legaspi Village, Makati City"
  },
  {
    branchcode: 287,
    label: "Legazpi City",
    address: "Block 2 Lot 3-B, Landco Business Park, Legaspi City, Albay"
  },
  {
    branchcode: 532,
    label: "Leviste",
    address:
      "Unit Ground B, LPL Mansions Building, 122 L.P. Leviste Street, Salcedo Village Makati City"
  },
  {
    branchcode: 78,
    label: "Lipa City",
    address: "No. 18, Lot 712 ABC, B. Morada Avenue, Lipa City, Batangas"
  },
  {
    branchcode: 249,
    label: "Loyola Heights-Katipunan",
    address:
      "Unit 13, Elizabeth Hall Bldg., Lot 1 Blk.41, Katipunan Avenue, Loyola Heights, Quezon City"
  },
  {
    branchcode: 34,
    label: "Lucena City",
    address:
      "Quezon Avenue corner Rosas Street, Barangay 8, Lucena City, Quezon"
  },
  {
    branchcode: 202,
    label: "Makati Ave.-Juno",
    address:
      "Unit No. 2, A and W Building, No. 1 Juno St. corner Makati Avenue, Brgy. Bel-air, Makati City"
  },
  {
    branchcode: 84,
    label: "Malabon-Gov. Pascual",
    address: "Gov. Pascual Ave. Cor. Maria Clara St., Acacia, Malabon City"
  },
  {
    branchcode: 116,
    label: "Malabon-Potrero",
    address:
      "Unit 1 & 2 Mary Grace Bldg. No. 142 Mac Arthur Highway, Potrero, Malabon"
  },
  {
    branchcode: 250,
    label: "Malabon-Rizal Avenue",
    address: "No. 726 Rizal Ave., Brgy. Tanong, Malabon City"
  },
  {
    branchcode: 540,
    label: "Malolos",
    address:
      "G/F, BUFECO Bldg., No. 1197 Brgy. Sumapang Matanda, Mac Arthur Highway Malolos, Bulacan"
  },
  {
    branchcode: 273,
    label: "Mandaluyong - Wack-Wack",
    address:
      "G/F , Unit JI-E, Jovan Condominium, Shaw Blvd. corner Samat St., Madaluyong City"
  },
  {
    branchcode: 119,
    label: "Mandaluyong-Libertad",
    address:
      "G/F-Units A,B & C, Dr. Aguilar Bldg. No 46 D.M. Guevarra St., cor Esteban St. Highway Hills Mandaluyong City"
  },
  {
    branchcode: 25,
    label: "Mandaluyong-Shaw Blvd.",
    address:
      "G/F, Unit No. 7, Sunshine Square, Liberty Center, Shaw Blvd., Mandaluyong City"
  },
  {
    branchcode: 169,
    label: "Marikina-Concepcion",
    address: "Bayan- Bayanan Ave.,Concepcion, Marikina City"
  },
  {
    branchcode: 137,
    label: "Marikina-Gil Fernando",
    address:
      "Gil Fernando Ave. cor. Estrador St., Midtown Phase 1, San Roque, Marikina City"
  },
  {
    branchcode: 251,
    label: "Marikina-J.P. Rizal",
    address: "No. 367 J.P.Rizal St., Sta.Elena, Marikina City"
  },
  {
    branchcode: 291,
    label: "Marikina-Parang",
    address: "JNJ Bldg., No. 108 BG Molina St., Parang, Marikina"
  },
  {
    branchcode: 183,
    label: "Masambong",
    address:
      "L.G. Atkimson Bldg., No. 627 Del Monte Ave., Brgy. Masambong, Quezon City"
  },
  {
    branchcode: 184,
    label: "Masangkay",
    address: "1411-1413 Masangkay St., Tondo, Manila"
  },
  {
    branchcode: 151,
    label: "Mayon",
    address: "No. 170 Mayon Avenue, Quezon City"
  },
  {
    branchcode: 560,
    label: "Mayon-Dapitan",
    address:
      "No. 181  Mayon St. near corner Dapitan St. Brgy. Sta. Teresita Quezon City"
  },
  {
    branchcode: 147,
    label: "Metropolitan Avenue",
    address:
      "Savana Bldg 3 Metropolitan Avenue corner Venezia st. Bgy. Sta Cruz, Makati City"
  },
  {
    branchcode: 253,
    label: "Meycauayan-Malhacan",
    address: "Meycauayan Tollgate, Meaycauayan City, Bulacan"
  },
  {
    branchcode: 538,
    label: "MIA Road",
    address: "Salud-Dizon Building 1, No. 5 MIA Road, Tambo, Parañaque City"
  },
  {
    branchcode: 220,
    label: "Mindoro-Calapan",
    address:
      "G/F Paras Bldg., J.P. Rizal St., Bgy. San Vicente South, Calapan, Oriental Mindoro"
  },
  {
    branchcode: 569,
    label: "Montalban-Rizal",
    address: "No. 240 E. Rodriguez Hi-way, Manggahan, Rodriguez, Rizal"
  },
  {
    branchcode: 122,
    label: "Muntinlupa",
    address:
      "G/F Remenes Center Building, No. 22 National Highway, Putatan, Muntinlupa City 1772"
  },
  {
    branchcode: 58,
    label: "Naga City",
    address:
      "g/f, LAM Bldg., No. 19 Peñafrancia Avenue, Zone 1, Brgy. San Francisco, Naga City, Camarines Sur"
  },
  {
    branchcode: 292,
    label: "Navotas-M. Naval",
    address: "No. 895 M. Naval Street, Brgy. Sipac-Almasen, Navotas City"
  },
  {
    branchcode: 121,
    label: "Navotas-North Bay",
    address:
      "G/F, Unit 2 Melandria III Building, No. 1090 Northbay Blvd., Navotas City"
  },
  {
    branchcode: 67,
    label: "New Manila",
    address: "G/F, AAP Building, No. 683 Aurora Blvd  New Manila Quezon City"
  },
  {
    branchcode: 205,
    label: "North EDSA",
    address:
      "UGF units 4,5,6&7 EDSA Grand Residences, EDSA cor. Corregidor St., Quezon City"
  },
  {
    branchcode: 110,
    label: "Novaliches-Gulod",
    address: "Lot 489-B2 Quirino Highway, Brgy. Gulod, Novaliches, Quezon City"
  },
  {
    branchcode: 266,
    label: "Novaliches-Talipapa",
    address:
      "G/F Units C, D, E, F & G No. 526 Quirino Highway, Brgy. Talipapa, Novaliches, Quezon City"
  },
  {
    branchcode: 288,
    label: "Nueva Ecija-Gapan",
    address: "TSI Bldg., Jose abad Santos Ave., Sto. Niño, Gapan, Nueva Ecija"
  },
  {
    branchcode: 262,
    label: "Nueva Ecija-San Jose",
    address:
      "Paulino Building, Brgy. Abar 1st Maharlika Road, San Jose Nueva Ecija"
  },
  {
    branchcode: 541,
    label: "Nueva Ecija-Talavera",
    address: "Lot No. 269-A Maharlika Road, Poblacion, Talavera, Nueva Ecija"
  },
  {
    branchcode: 263,
    label: "Nueva Vizcaya-Solano",
    address: "Maharlika Road, Poblacion, Solano, Nueva Vizcaya"
  },
  {
    branchcode: 108,
    label: "Olongapo City",
    address: "No. 1215 Rizal Ave., West Tapinac, Olongapo City"
  },
  {
    branchcode: 293,
    label: "Ongpin",
    address:
      "g/f, Unit G1, Strata Gold Condominium Bldg., No. 738 Ongpin St., Binondo, Manila"
  },
  {
    branchcode: 254,
    label: "Ormoc City",
    address: "G/F Hotel Don Felipe Annex Bldg. Bonifacio St., Ormoc City"
  },
  {
    branchcode: 603,
    label: "Ortigas - Orient Square",
    address:
      "G/F Orient Square Building, Emerald Ave., Ortigas Center Pasig City"
  },
  {
    branchcode: 566,
    label: "Ortigas-ADB Avenue",
    address:
      "G/F, Units G1 & G2, ADB Avenue Tower, ADB Avenue, Ortigas Center, Pasig City"
  },
  {
    branchcode: 112,
    label: "Ortigas-Emerald",
    address:
      "G/F, Unit 103 Hanston Bldg., Don F. Ortigas Jr. Road, Ortigas Center, Pasig City"
  },
  {
    branchcode: 255,
    label: "Ortigas-Garnet",
    address:
      "Unit 102, Prestige Tower, Emerald Ave., Ortigas Center, Pasig City"
  },
  {
    branchcode: 148,
    label: "Ortigas-Rockwell",
    address:
      "Unit No. W-01 Tower 1, The Rockwell Business Center, Ortigas Avenue, Pasig"
  },
  {
    branchcode: 126,
    label: "Ozamiz City",
    address: "G/F, Casa Esperanza, Don Anselmo Bernard Ave., Ozamiz City, 7200"
  },
  {
    branchcode: 568,
    label: "P.Ocampo Avenue",
    address:
      "No. 245 P.Ocampo Ave. corner Flordeliz St., Brgy. La Paz, Makati City"
  },
  {
    branchcode: 100,
    label: "Paco",
    address: "No. 1050 Pedro Gil St., Paco, Manila"
  },
  {
    branchcode: 22,
    label: "Padre Faura",
    address:
      "G/F, Units A-D, Metrosquare Bldg. 2, No. 1241 M.H. Del Pilar St. corner Padre Faura St., Ermita, Manila"
  },
  {
    branchcode: 186,
    label: "Pagadian City",
    address:
      "BMD Estate Bldg., F. Pajares cor. Sanson St., Pagadian City, Zamboanga del Sur"
  },
  {
    branchcode: 187,
    label: "Palawan",
    address: "Rizal Avenue, Brgy. Manggahan, Puerto Princesa City, Palawan"
  },
  {
    branchcode: 44,
    label: "Pampanga-Angeles City",
    address:
      "Unit 4-7 AYA Bldg. Sto. Rosario Street, Brgy. San Jose, Angeles City, Pampanga"
  },
  {
    branchcode: 167,
    label: "Pampanga-Apalit",
    address: "Bgy. San Vicente, Apailt, Pampanga"
  },
  {
    branchcode: 596,
    label: "Pampanga-Clark",
    address:
      "Pavilion 16 Berthaphil Clark Center, Jose Abad Santos ave., TFZ Clark SPCL Ecozone, Angeles City, Pampanga"
  },
  {
    branchcode: 243,
    label: "Pampanga-Guagua",
    address:
      "Goodluck Bldg., No. 303 Guagua-Sta. Rita Arterial Road, Brgy. San Roque, Guagua, Pampanga"
  },
  {
    branchcode: 579,
    label: "Pangasinan - Mangaldan",
    address:
      "Cadastral Lot No. 335 Rizal Ave., Brgy. Poblacion, Mangaldan, Pangasinan"
  },
  {
    branchcode: 586,
    label: "Pangasinan-Alaminos",
    address:
      "BHF Blue Horizon Bldg., Quezon Ave., Poblacion , Alaminos City, Pangasinan"
  },
  {
    branchcode: 296,
    label: "Pangasinan-Lingayen",
    address: "Avenida Rizal East Road, Lingayen, Pangasinan"
  },
  {
    branchcode: 218,
    label: "Pangasinan-Rosales",
    address:
      "Estrella Compound, Carmen East Rosales, Mac Arthur Highway Pangasinan."
  },
  {
    branchcode: 149,
    label: "Pangasinan-San Carlos",
    address: "Palaris St. cor. Jaycees St., San Carlos, Pangasinan"
  },
  {
    branchcode: 180,
    label: "Pasay-D. Macapagal Blvd",
    address: "No. 8 President Diosdado Macapagal Blvd., Pasay City"
  },
  {
    branchcode: 212,
    label: "Pasay-Libertad",
    address: "Unit 265-E Nemar Building , Libertad St. Pasay City"
  },
  {
    branchcode: 555,
    label: "Pasay-Oceanaire",
    address:
      "Ground Floor Unit No. 108 & 109, Podium Commercial Area, Oceanaire Condominium, Sunrise Drive corner Rd. 23, SM Mall of Asia Complex, Pasay City"
  },
  {
    branchcode: 132,
    label: "Paseo de Magallanes",
    address:
      "G/F Unit 102, Tritan Plaza Building, San Antonio St., Paseo De Magallanes, Makati City Philippines, 1232"
  },
  {
    branchcode: 75,
    label: "Paseo de Roxas-Legaspi",
    address:
      "G/F, 111 Paseo De Roxas Bldg., 111 Paseo de Roxas St. corner Legaspi St., Legaspi Village, Makati City"
  },
  {
    branchcode: 87,
    label: "Paseo-Philam Tower",
    address: "G/F, Philamlife Tower, 8767 Paseo de Roxas St., Makati City 1226"
  },
  {
    branchcode: 150,
    label: "Pasig Boulevard",
    address:
      "corner Pasig Blvd. and Lakeview Drive, Brgy. Bagong Ilog, Pasig City"
  },
  {
    branchcode: 259,
    label: "Pasig Rosario",
    address: "Unit 3, 1866 Ortigas Ave., Ext., Rosario, Pasig City"
  },
  {
    branchcode: 8,
    label: "Pasig-Kapasigan",
    address: "A.Mabini corner Blumentrit Street, Brgy. Kapasigan, Pasig City"
  },
  {
    branchcode: 260,
    label: "Pasig-Santolan",
    address: "G/F Santolan Bldg., 344 A. Rodriguez Avenue, Santolan, Pasig City"
  },
  {
    branchcode: 7,
    label: "Pasig-Shaw Blvd.",
    address:
      "Units A&B Karina Bldg., No. 33 Shaw Blvd., Brgy. San Antonio, District 1, Pasig City"
  },
  {
    branchcode: 258,
    label: "Pasig-Valle Verde",
    address: "102 E. Rodriguez, Jr. Ave., Ugong, Pasig City"
  },
  {
    branchcode: 82,
    label: "Paso De Blas",
    address: "No. 191 Paso De Blas, Valenzuela City"
  },
  {
    branchcode: 24,
    label: "Pasong Tamo Extension",
    address: "G/F Dacon Bldg., 2281 Pasong Tamo Extension, Makati City"
  },
  {
    branchcode: 556,
    label: "Pateros",
    address: "M. Almeda corner G. De Borja Street, San Roque, Pateros"
  },
  {
    branchcode: 533,
    label: "Paz M. Guazon",
    address:
      "Units 5 & 6 Topmark Bldg., 1763 Paz M. Guazon Street, Paco, Manila"
  },
  {
    branchcode: 559,
    label: "Pedro Gil",
    address: "No. 574 Pedro Gil Street, Malate Manila"
  },
  {
    branchcode: 508,
    label: "Perea",
    address:
      "G/F Greenbelt Mansion, 106 Perea Street, Legaspi Village, Makati City"
  },
  {
    branchcode: 107,
    label: "Pioneer",
    address:
      "UG-09 Pioneer Pointe Condominium Pioneer St. Highway Hills Mandaluyong City"
  },
  {
    branchcode: 15,
    label: "President's Avenue",
    address: "No. 35 President's Avenue, BF Homes, Paranaque City 1700"
  },
  {
    branchcode: 520,
    label: "Project 8-Shorthorn",
    address:
      "G/F, West Star Business Center Bldg., No. 31 Shorthorn St., Brgy. Bahay Toro, Project 8, Quezon City"
  },
  {
    branchcode: 29,
    label: "Quezon Ave.-Banawe",
    address: "G/F PPSTA 1 Building Quezon Ave. cor. Banawe St., Quezon City"
  },
  {
    branchcode: 207,
    label: "Quezon Ave-Dr. Garcia",
    address:
      "G/F, Kayumanggi Press Bldg., No. 940 Quezon Ave., near cor. Dr. Garcia St., Brgy. Paligsahan Quezon City"
  },
  {
    branchcode: 109,
    label: "Quezon Ave-Sct Albano",
    address:
      "Quezon Ave., near cor. Scout Albano, Bgy. South Triangle, Quezon City"
  },
  {
    branchcode: 26,
    label: "Quezon Ave-Sct Santiago",
    address:
      "Unit No. 2G-7 and 2G-8, Sunshine Boulevard Plaza, No. 1328 Quezon Ave. cor. Scout Santiago St., Brgy. South Triangle, Quezon City"
  },
  {
    branchcode: 199,
    label: "Quiapo",
    address:
      "E&L Haw Dynasty Bldg. No. 502 Evangelista St., corner P. Paterno St., Quiapo, Manila"
  },
  {
    branchcode: 189,
    label: "Rada",
    address:
      "G/F, Unit No. 102, La Maision Rada Condominium Bldg., Rada St., Legaspi Village, Makati City"
  },
  {
    branchcode: 17,
    label: "Regalado",
    address: "Regalado Ave. Cor. Archer St., North Fairview Subd. Quezon City"
  },
  {
    branchcode: 6,
    label: "Roosevelt-Frisco",
    address: "No. 184 Roosevelt Avenue, San Francisco Del Monte, Quezon City"
  },
  {
    branchcode: 190,
    label: "Roosevelt-Sto. Niño",
    address:
      "187 Roosevelt Avenue, Brgy. Sto. Niño, San Francisco Del Monte, Quezon City"
  },
  {
    branchcode: 114,
    label: "Roxas Boulevard",
    address: "G/F, DENR Building, 1515 Roxas Boulevard, Ermita, Manila"
  },
  {
    branchcode: 504,
    label: "Roxas City",
    address:
      "Corner Roxas Avenue and Osmeña St. (formerly Pavia St.), Roxas City, Capiz"
  },
  {
    branchcode: 48,
    label: "Salcedo",
    address:
      "G/F First Life Center, 174 Salcedo St.,Legaspi Village Makati City"
  },
  {
    branchcode: 534,
    label: "Sampaloc-J. Figueras",
    address: "No. 427-433 J. Figueras Street, Sampaloc, Manila"
  },
  {
    branchcode: 32,
    label: "San Fernando-Dolores",
    address:
      "Felix S. David Bdg., MacArthur Highway, Dolores, San Fernando City, Pampanga"
  },
  {
    branchcode: 516,
    label: "San Fernando-JASA",
    address:
      "G/F, Units 1A &1B Kingsborough Commercial Center Building, Jose Abad Santos Avenue, San Fernando, Pampanga 2000"
  },
  {
    branchcode: 191,
    label: "San Fernando-Sindalan",
    address:
      "T & M Building, Mac Arthur Highway, Brgy. Sindalan, San Fernando, Pampanga"
  },
  {
    branchcode: 102,
    label: "San Juan",
    address:
      "EastWest Bank Bldg. F. Blumentritt , corner M. Salvador, Barangay San Perfecto San Juan City"
  },
  {
    branchcode: 257,
    label: "San Lorenzo-A. Arnaiz",
    address:
      "The E-Hotels Makati Bldg., No. 906 A. Arnaiz Ave., (formerly Pasay Rd.) San Lorenzo Village, Makati City"
  },
  {
    branchcode: 592,
    label: "San Mateo",
    address: "Lot 551-A-8 Gen. Luna St., Brgy. Ampid, San Mateo, Rizal"
  },
  {
    branchcode: 88,
    label: "San Miguel Ave.",
    address:
      "G/F, Medical Plaza Building, San Miguel Avenue, Ortigas Center, Pasig City"
  },
  {
    branchcode: 127,
    label: "San Pablo",
    address:
      "Lots 2365 & 3152, J. P. Rizal Avenue, Poblacion, San Pablo City, Laguna"
  },
  {
    branchcode: 128,
    label: "San Pedro",
    address: "National Highway, Brgy. Nueva, San Pedro, Laguna"
  },
  {
    branchcode: 546,
    label: "Silay",
    address: "Rizal Street, Silay City, Negros Occidental"
  },
  {
    branchcode: 101,
    label: "Soler",
    address: "G/F, R & S Tower, 941 Soler St., Binondo, Manila"
  },
  {
    branchcode: 545,
    label: "Sorsogon City",
    address:
      "Ma. Bensuat T. Dogillo Bldg., Magsaysay St., Poblacion, Sorsogon City"
  },
  {
    branchcode: 558,
    label: "Sta. Rosa",
    address:
      "Unit No. 6, Paseo 5 - Paseo de Sta Rosa, Greenfield  City, Don Jose, Santa Rosa City, Laguna"
  },
  {
    branchcode: 23,
    label: "Sto. Cristo",
    address:
      "Unit 108, Sto. Cristo condominium, Sto Cristo corner Ilang-Ilang Sts., San Nicolas, Binondo, Manila"
  },
  {
    branchcode: 298,
    label: "Subic Bay",
    address: "No. 1109 Rizal Highway, Subic Bay Freeport Zone, Olongapo City"
  },
  {
    branchcode: 161,
    label: "Sucat-Evacom",
    address:
      "8208 Dr. A. Santos Avenue Barangay San Isidro, Paranaque City 1700"
  },
  {
    branchcode: 274,
    label: "Sucat-Kabihasnan",
    address:
      "G/F Unit 3 & 4 Perry Logistics Center Building, Ninoy Aquino Avenue, Paranaque City"
  },
  {
    branchcode: 192,
    label: "Sucat-Kingsland",
    address:
      "G/F and 2/F, No. 5 & 6, Kingsland Building, Dr. A. Santos Avenue, Sucat, Paranaque City"
  },
  {
    branchcode: 43,
    label: "Sucat-NAIA",
    address:
      "Unit 707-6 Columbia AirFreight Complex, Miescor Drive, Ninoy Aquino Ave. Brgy. Sto. Niño Paranaque City 1700"
  },
  {
    branchcode: 264,
    label: "Surigao City",
    address: "G/F, EGC Building, Rizal Street, Washington, Surigao City"
  },
  {
    branchcode: 54,
    label: "T. Alonzo",
    address: "No. 623 T. Alonzo St., Brgy. 300, Zone 029, Sta. Cruz, Manila"
  },
  {
    branchcode: 195,
    label: "T.M. Kalaw",
    address: "A-1,2,3 & 4 Ditz Bldg., 444 T.M. Kalaw St., Ermita, Manila"
  },
  {
    branchcode: 565,
    label: "Tabaco City",
    address: "Manuel Cea Bldg. I, Santillan St., Poblacion, Tabaco City, Albay"
  },
  {
    branchcode: 506,
    label: "Tacloban City-Marasbaras",
    address: "G/F, JGC Bldg., Brgy. 77, Marasbaras, Tacloban City"
  },
  {
    branchcode: 590,
    label: "Tacloban-J. Romualdez",
    address: "RUL Building, Justice Romualdez St., Brgy.15, Tacloban City"
  },
  {
    branchcode: 597,
    label: "Tacurong",
    address:
      "Tacurong City-Lambayong, National Highway, Tacurong, Sultan Kudarat"
  },
  {
    branchcode: 193,
    label: "Taft Avenue",
    address:
      "Philippine Academy of Family Physicians (PAFP) Bldg. 2244 Taft Avenue, Manila"
  },
  {
    branchcode: 141,
    label: "Taft-Nakpil",
    address:
      "RLR Building, 1820 Taft Avenue near corner Nakpil Street, Malate, Manila"
  },
  {
    branchcode: 599,
    label: "Tagaytay",
    address:
      "G/F, Unit 1001.1, Fora Mall, Emilio Aguinaldo Highway, Brgy. Crossing East, Rotunda, Tagaytay City, Cavite"
  },
  {
    branchcode: 265,
    label: "Tagbilaran City",
    address: "CPG Avenue, 2nd District, Tagbilaran City"
  },
  {
    branchcode: 152,
    label: "Tagum City",
    address:
      "Gaisano Grand ArcadeE, Apokon Road cor. Lapu-Lapu Ext., Brgy. Visayan Village, Tagum City"
  },
  {
    branchcode: 21,
    label: "Tandang Sora",
    address:
      "Lot 80 - A Kalaw Hills Subd. Brgy. Culiat Tandang Sora Quezon City"
  },
  {
    branchcode: 576,
    label: "Tarlac - Concepcion",
    address:
      "Lot No. 1889, B1,B2,B3, L. Cortez St., San Nicolas, Concepcion, Tarlac"
  },
  {
    branchcode: 578,
    label: "Tarlac - McArthur Highway",
    address:
      "Lot No. 27 Block 17, McArthur Highway corner Calle Manuel, San Sebastian Village, Tarlac, Tarlac"
  },
  {
    branchcode: 53,
    label: "Tarlac-F. Tañedo",
    address: "Mariposa Bldg.,F. Tanedo St., Tarlac City"
  },
  {
    branchcode: 256,
    label: "Tarlac-Paniqui",
    address:
      "No. 130 M.H. Del Pilar St., cor. Mac Arthur Highway, Paniqui, Tarlac City"
  },
  {
    branchcode: 143,
    label: "Taytay-Manila East",
    address: "Manila East Road, Brgy. San Juan, Taytay Rizal"
  },
  {
    branchcode: 11,
    label: "Taytay-Ortigas Ext.",
    address: "Vallley Fait Town Center, Ortigas Ave., Extension, Taytay, Rizal"
  },
  {
    branchcode: 49,
    label: "Tektite",
    address:
      "G/F, East Tower, PSE Center, Exchange Drive, Ortigas Center, Pasig City"
  },
  {
    branchcode: 554,
    label: "The Fort-Active Fun",
    address:
      "G/F Active Fun Building, 9th Avenue corner 28th Street, City Center, Bonifacio Global City, Taguig City"
  },
  {
    branchcode: 602,
    label: "The Fort-B3 Bonifacio High St.",
    address:
      "G/F Quadrant 3 Wumaco Bldg. 2, 7th Avenue B3, Bonifacio High Street, Bonifacio Global City, Taguig"
  },
  {
    branchcode: 203,
    label: "The Fort-Beaufort",
    address:
      "The Beaufort G/F 5th Avenue Cor. 23rd St. Bonifacio Global City, Taguig City"
  },
  {
    branchcode: 595,
    label: "The Fort-BGC Corporate Center",
    address:
      "G/F, Unit No. 2, BGC Corporate Center, No. 3030 11th Ave. cor. 30th St., City Center, Bonifacio Global City, Taguig City 1634"
  },
  {
    branchcode: 125,
    label: "The Fort-Burgos Circle",
    address:
      "G/F Units H & I, Crescent Park Residences, 30th St. corner 2nd Avenue, Bonifacio Global City, Taguig City."
  },
  {
    branchcode: 268,
    label: "The Fort-F1 Center",
    address:
      "G/F, Unit D, F1 City Center, 32nd Street near corner 5th Avenue, Bonifacio Global City, Taguig City"
  },
  {
    branchcode: 79,
    label: "The Fort-Marajo Tower",
    address:
      "G/F The Marajo Tower,  26th St. corner 4th Avenue, Fort Bonifacio, Global City Taguig"
  },
  {
    branchcode: 605,
    label: "The Fort-PSE Tower",
    address:
      "5th Floor, One Bonifacio High Street Philippine Stock Exchange Tower ( One BHS PSE Tower), 5th Avenue cor. 28th Street, Bonifacio Global City, Taguig City"
  },
  {
    branchcode: 261,
    label: "The Fort-South of Market",
    address:
      "g/f, Units 25 and 26, North Tower, South of Market (SOMA) Building, 26th St. cor. 11th Ave., Bonifacio Global City, Taguig City"
  },
  {
    branchcode: 157,
    label: "Timog Ave.",
    address: "G/F Timog Arcade,Timog Avenue cor. Sct. Torillo, Quezon City"
  },
  {
    branchcode: 570,
    label: "Timog-Mother Ignacia",
    address: "No. 21 Timog Ave., Brgy. South Triangle,  Quezon City 1103"
  },
  {
    branchcode: 194,
    label: "Tomas Mapua-Lope de Vega",
    address:
      "G/F & 2/F, Valqua Building., 1003 Tomas Mapua St. cor. Lope de Vega St., Sta. Cruz, Manila"
  },
  {
    branchcode: 42,
    label: "Tomas Morato",
    address: "No. 257 Tomas Morato St. near cor. Scout Fuentabella, Quezon City"
  },
  {
    branchcode: 524,
    label: "Tordesillas",
    address:
      "Unit 105, Le Metropole Condominium, H.V. Dela Costa cor. and Tordesillas Sts. & Sen. Gil Puyat Ave., Salcedo Village, Makati City"
  },
  {
    branchcode: 136,
    label: "Tuguegarao City",
    address:
      "College Ave. cor Rizal and Bonifacio St., Brgy. 08, Poblacion, Tuguegarao City"
  },
  {
    branchcode: 93,
    label: "UN Avenue",
    address:
      "MAGCOOP Bldg., UN Avenue St. near corner A. Mabini St., Ermita, Manila"
  },
  {
    branchcode: 196,
    label: "UP Village",
    address: "No. 65 Maginhawa St., U.P. Village, Diliman, quezon City"
  },
  {
    branchcode: 81,
    label: "Urdaneta City",
    address: "S&P Bldg., Mc Arthur Highway, Nancayasan, Urdaneta City"
  },
  {
    branchcode: 289,
    label: "Valenzuela-Dalandanan",
    address:
      "Malanday Machinery's Commercial Bldg., No. 212 Km. 15 Mac Arthur Highway, Brgy. Dalandanan, Valenzuela City"
  },
  {
    branchcode: 536,
    label: "Valenzuela-Gen. T. De Leon",
    address:
      "G/F, Units 4 & 5, Liu Shuang Yu Bldg., No. 3026 Gen. T. De Leon St., Brgy. Gen. T. De Leon, Valenzuela City"
  },
  {
    branchcode: 45,
    label: "Valenzuela-Marulas",
    address:
      "JLB Enterprises Bldg., KM 12 McArthur Highway, Marulas, Valenzuela City"
  },
  {
    branchcode: 47,
    label: "Valero",
    address:
      "G/F, Retail 1B, Paseo Park View Tower 1, 140 Valero St., Salcedo Village, Makati City"
  },
  {
    branchcode: 269,
    label: "Vigan",
    address: "Quezon Ave., Vigan City Ilocos Sur"
  },
  {
    branchcode: 280,
    label: "Visayas Avenue",
    address:
      "G/F, K.L. Group Bldg., Units B, C, & D, No. 15 Visayas Ave., Brgy. Vasra, Quezon City"
  },
  {
    branchcode: 56,
    label: "West Avenue",
    address:
      "No. 108 West Avenue corner West Lawin Street, West Triangle, Quezon City"
  },
  {
    branchcode: 158,
    label: "West Service Road",
    address:
      "West Service Road corner Sampaguita Avenue UPS IV Subd., Paranaque City 1700"
  },
  {
    branchcode: 159,
    label: "Wilson",
    address: "No. 220-B Wilson St., San Juan City"
  },
  {
    branchcode: 564,
    label: "Xavierville",
    address:
      "No. 60 Xavierville Avenue, Xavierville Subdivision, Brgy. Loyola Heights, Quezon City"
  },
  {
    branchcode: 294,
    label: "Ylaya-Padre Rada",
    address:
      "G/F Josefa Building No. 981, Ylaya Street corner Padre Rada Street Tondo, Manila"
  },
  {
    branchcode: 542,
    label: "Zambales-Iba",
    address:
      "Lot No. 1-A, Zambales - Pangasinan Provincial Road, Brgy. Sagapan, Iba, Zambales"
  },
  {
    branchcode: 270,
    label: "Zamboanga-Canelar",
    address: "Printex Bldg., Mayor Jaldon St., Zamboanga City"
  },
  {
    branchcode: 39,
    label: "Zamboanga-NS Valderrosa",
    address: "N.S. Valderrosa St. corner Corcuerra St., Zamboanga City"
  }
];
